import { CSSResultGroup, TemplateResult, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import componentStyles from './sic-annuities-distributors-hero.css.lit';

/*
 * The annuities distributors hero component
 * @element sic-annuities-distributors-hero
 *
 * @slot logo - Logo
 * @slot dropdown title - Title of the dropdown menu
 * @slot dropdown menu - The dropdown menu
 * @slot cta-title - Title cta menu
 * @slot cta-menu - menu of cta links for the annuities hero
 *
 * Lightdom styles in sic-annuities-distributors.lightdom.css included in /shared.css
 */
@customElement('sic-annuities-distributors-hero')
export class SicAnnuitiesDistributorsHero extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  render(): TemplateResult {
    return html`
      <div class="annuities-distributors-hero-wrapper">
        <div class="text-wrapper">
          <slot name="logo"></slot>
          <div class="drop-down-wrapper">
            <slot name="dropdown-title"></slot>
            <slot name="dropdown-menu"></slot>
          </div>
        </div>
        <div class="cta-menu-wrapper">
          <slot name="cta-title"></slot>
          <slot name="cta-menu"></slot>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sic-annuities-distributors-hero': SicAnnuitiesDistributorsHero;
  }
}
